import { atomWithStorage, createJSONStorage } from 'jotai/utils'

// getOnInit: true → atom reads localStorage synchronously on first access so
// any effect that runs on the first render sees the persisted user selection
// (e.g. App.tsx's country-default guard `if (def && !language)`).
export const languageState = atomWithStorage<string>(
    'u25:language',
    '',
    createJSONStorage<string>(() => localStorage),
    { getOnInit: true }
)
